<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="missionPlace" class="my-3 theme-main-color">
		<div class="">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ missionPlace.name }}</span
					>
				</div>

				<div *ngIf="isDeletable" class="">
					<a
						(click)="openConfirmDeleteModal(deleteMissionPlace)"
						class="btn theme-red-button px-3"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="row rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col">
						<label
							for="inputAddresse"
							class="form-label theme-main-color fw-bold"
							>Adresse</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">{{
							missionPlace.address.label
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<label for="specialties" class="form-label fw-bold"
						>Spécialité(s)</label
					>
					<span *ngIf="isFormReadOnly" class="form-control-plaintext ps-3">{{
						specialitiesAsString()
					}}</span>
				</div>

				<div class="row my-4">
					<div class="col">
						<label for="inputNotes" class="form-label theme-main-color fw-bold"
							>Notes</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">{{
							missionPlace.notes
						}}</span>
					</div>
				</div>
			</div>
			<app-mission-place-form
				*ngIf="!isFormReadOnly"
				[missionPlace]="missionPlace"
				[form]="missionPlaceDetailForm"
				[isAddForm]="false"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			></app-mission-place-form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(false)"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="
						!missionPlaceDetailForm.valid || isValidateButtonClicked.value
					"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteMissionPlace>
	<div class="modal-header text-center">
		<h4>Suppression</h4>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		>
			<span aria-hidden="true"></span>
		</button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir supprimer le lieu de {{ labelIntervention }} ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete(missionPlace)"
			>Supprimer</a
		>
	</div>
</ng-template>
